export default "__VITE_ASSET__B0kURJ1J__"